import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EmailActionsEnum } from '@app-types/enums/EmailActions';
import { ValidateButtonComponent } from '@app-components/email/action-buttons/validate-button/validate-button.component';
import { FinalDeleteButtonComponent } from '@app-components/email/action-buttons/final-delete-button/final-delete-button.component';
import { ReplyButtonComponent } from '@app-components/email/action-buttons/reply-button/reply-button.component';
import { ReplyAllButtonComponent } from '@app-components/email/action-buttons/reply-all-button/reply-all-button.component';
import { ForwardButtonComponent } from '@app-components/email/action-buttons/forward-button/forward-button.component';
import { ForwardAttachmentButtonComponent } from '@app-components/email/action-buttons/forward-attachment-button/forward-attachment-button.component';
import { ReassignButtonComponent } from '@app-components/email/action-buttons/reassign-button/reassign-button.component';
import { GroupsButtonComponent } from '@app-components/email/action-buttons/groups-button/groups-button.component';
import { TagsButtonComponent } from '@app-components/email/action-buttons/tags-button/tags-button.component';
import { SetReadButtonComponent } from '@app-components/email/action-buttons/set-read-button/set-read-button.component';
import { SetUnreadButtonComponent } from '@app-components/email/action-buttons/set-unread-button/set-unread-button.component';
import { MarkAsSpanButtonComponent } from '@app-components/email/action-buttons/mark-as-span-button/mark-as-span-button.component';
import { DeleteButtonComponent } from '@app-components/email/action-buttons/delete-button/delete-button.component';
import { DownloadSingleEmlButtonComponent } from '@app-components/email/action-buttons/download-single-eml-button/download-single-eml-button.component';
import { DownloadEmlButtonComponent } from '@app-components/email/action-buttons/download-eml-button/download-eml-button.component';
import { RestoreButtonComponent } from '@app-components/email/action-buttons/restore-button/restore-button.component';
import { MarkAsNotSpanButtonComponent } from '@app-components/email/action-buttons/mark-as-not-span-button/mark-as-not-span-button.component';
import { MoveToFolderButtonComponent } from '@app-components/email/action-buttons/move-to-folder-button/move-to-folder-button.component';
import { ArchiveButtonComponent } from '@app-components/email/action-buttons/archive-button/archive-button.component';
import { AuditButtonComponent } from '@app-components/email/action-buttons/audit-button/audit-button.component';
import { RetrySendingButtonComponent } from '@app-components/email/action-buttons/retry-sending-button/retry-sending-button.component';
import { RestoreArchiveButtonComponent } from '@app-components/email/action-buttons/restore-archive-button/restore-archive-button.component';
import { EmailsService } from '@app-services/emails/emails.service';
import { ButtonActionsService } from '@app-services/emails/button-actions/button-actions.service';
import { ActionsModalsService } from '@app-services/emails/button-actions/actions-modal.service';
import { ActionsService } from '@app-services/emails/button-actions/actions.service';
import { EmailsPageStateService } from '@app-services/emails/emails-page-state.service';
import { StarButtonComponent } from '@app-components/email/action-buttons/star-button/star-button.component';
import { ArchivingButtonComponent } from '@app-components/email/action-buttons/archiving-button/archiving-button.component';

@Component({
  selector: 'app-emails-header-action-buttons',
  templateUrl: './emails-header-action-buttons.component.html',
  styleUrls: ['./emails-header-action-buttons.component.scss'],
  imports: [
    TranslateModule,
    ValidateButtonComponent,
    FinalDeleteButtonComponent,
    ReplyButtonComponent,
    ReplyAllButtonComponent,
    ForwardButtonComponent,
    ForwardAttachmentButtonComponent,
    ReassignButtonComponent,
    GroupsButtonComponent,
    TagsButtonComponent,
    SetReadButtonComponent,
    SetUnreadButtonComponent,
    MarkAsSpanButtonComponent,
    DeleteButtonComponent,
    DownloadSingleEmlButtonComponent,
    DownloadEmlButtonComponent,
    RestoreButtonComponent,
    MarkAsNotSpanButtonComponent,
    MoveToFolderButtonComponent,
    ArchiveButtonComponent,
    AuditButtonComponent,
    RetrySendingButtonComponent,
    RestoreArchiveButtonComponent,
    StarButtonComponent,
    ArchivingButtonComponent,
  ],
})
export class EmailsHeaderActionButtonsComponent {
  public actionsModals: ActionsModalsService;
  public actions: ActionsService;

  EmailActionsEnum = EmailActionsEnum;

  constructor(
    protected emailsService: EmailsService,
    protected buttonActionsService: ButtonActionsService,
    public emailsPageStateService: EmailsPageStateService
  ) {
    this.actionsModals = buttonActionsService.actionsModals;
    this.actions = buttonActionsService.actions;
  }
}
